<template>
  <div id="lm-pagination" v-if="paginationNumbersShowed.length">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li
          :class="{disabled: isFirstPaginationReached}"
          class="page-item"
          id="first-link-wrapper"
          >
          <span
            @click="setPaginationNumberActivated(1)"
            class="page-link"
            id="first-link"
            >
              <font-awesome-icon
                class="d-inline d-md-none d-lg-none d-xl-none"
                icon="fast-backward"
                />
              <span class="d-none d-md-inline d-lg-inline d-xl-inline" >{{$t('first')}}</span>
          </span>
        </li>
        <li
          :class="{disabled: isFirstPaginationReached}"
          class="page-item"
          id="prev-link-wrapper"
          >
          <a
            @click="setPaginationNumberActivated(--activePagination)"
            class="page-link"
            id="prev-link"
            aria-label="Previous"
            >
            <font-awesome-icon
              class="d-inline d-md-none d-lg-none d-xl-none"
              icon="step-backward"
              />
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <div class="input-group mb-3" id="lm-pagination-numbers-mobile-wrapper">
          <select
            v-model.number="activePagination"
            @change="setPaginationNumberActivated(activePagination)"
            class="custom-select"
            id="lm-pagination-numbers-mobile"
            >
            <option v-for="(number, index) in allPaginationsNumbers" :key="index">{{number}}</option>
          </select>
        </div>
        <ul class="pagination lm-pagination-numbers">
          <li
            v-for="(number, index) in paginationNumbersShowed"
            :key="index"
            :class="{
              active: number === activePagination,
              disabled: number === activePagination
            }"
            class="page-item"
            >
            <a
              @click="setPaginationNumberActivated(null, $event)"
              class="page-link"
              >
                {{number}}
              </a>
          </li>
        </ul>
        <li :class="{disabled: this.isLastPaginationReached}" class="page-item">
          <a
            @click="setPaginationNumberActivated(++activePagination)"
            class="page-link"
            id="next-link"
            aria-label="Next">
            <font-awesome-icon
              class="d-inline d-md-none d-lg-none d-xl-none"
              icon="step-forward"
              />
            <span class="d-none d-md-inline d-lg-inline d-xl-inline" aria-hidden="true">&raquo;</span>
            <span class="sr-only d-none d-md-inline d-lg-inline d-xl-inline">{{$t('next')}}</span>
          </a>
        </li>
        <li
          :class="{disabled: this.isLastPaginationReached}"
          class="page-item"
          id="last-link"
          v-if="allRegistries < elasticSearchLimitQuery"
          >
          <span
            @click="setPaginationNumberActivated(allPaginationsNumbers)" class="page-link"
            >
              <font-awesome-icon
                class="d-inline d-md-none d-lg-none d-xl-none"
                icon="fast-forward"
                />
              <span class="d-none d-md-inline d-lg-inline d-xl-inline" >
                {{$t('last')}}
              </span>
            </span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFastBackward, faFastForward, faStepForward, faStepBackward } from '@fortawesome/free-solid-svg-icons'
library.add(faFastBackward, faFastForward, faStepForward, faStepBackward)

export default {
  data () {
    return {
      activePagination: 1,
      higherActivePaginationBeforeMutate: Math.ceil(this.maxAmountNumbersToShowInPagination / 2)
    }
  },
  computed: {
    allPaginationsNumbers () {
      return Math.ceil(this.allRegistries / this.maxAmountItemsShowsPerPaginationInTable)
    },
    paginationNumbersShowed () {
      let paginationNumbersShowedArray = []
      let loopIteration = 0
      let firstNumberShowedInPagination = 1
      if (this.maxAmountNumbersToShowInPagination < this.allPaginationsNumbers) {
        if (this.isFirstPartPaginationBeforeMutate) {
          firstNumberShowedInPagination = 1
        } else if (this.isLastPartPaginationBeforeMutate) {
          firstNumberShowedInPagination = this.allPaginationsNumbers - this.maxAmountNumbersToShowInPagination
          ++firstNumberShowedInPagination
        } else {
          firstNumberShowedInPagination = this.activePagination - this.higherActivePaginationBeforeMutate
        }
      }
      for (let i = firstNumberShowedInPagination; i <= this.allPaginationsNumbers; i++) {
        ++loopIteration
        paginationNumbersShowedArray.push(i)
        if (loopIteration === this.maxAmountNumbersToShowInPagination) {
          break
        }
      }
      return paginationNumbersShowedArray
    },
    isLastPaginationReached () {
      if (this.activePagination === this.allPaginationsNumbers) {
        return true
      } else {
        return false
      }
    },
    lastPartPagination () {
      return this.allPaginationsNumbers - (this.maxAmountNumbersToShowInPagination / 2)
    },
    isFirstPaginationReached () {
      if (this.activePagination === 1) {
        return true
      } else {
        return false
      }
    },
    isLastPartPaginationBeforeMutate () {
      return this.activePagination >= this.lastPartPagination
    },
    isFirstPartPaginationBeforeMutate () {
      return this.activePagination <= this.higherActivePaginationBeforeMutate
    }
  },
  props: {
    maxAmountNumbersToShowInPagination: {
      type: Number,
      default: 10
    },
    allRegistries: {
      type: Number,
      required: true
    },
    maxAmountItemsShowsPerPaginationInTable: {
      type: Number,
      required: true
    },
    elasticSearchLimitQuery: {
      type: Number,
      default: 10000
    }
  },
  watch: {
    allPaginationsNumbers () {
      this.setPaginationNumberActivated(1)
    }
  },
  methods: {
    setPaginationNumberActivated (numberActivated, event) {
      this.activePagination = numberActivated ? Number(numberActivated) : Number(event.target.innerText)
      this.$emit('paginationNumberClick', this.activePagination)
    }
  }
}
</script>

<style lang="sass" scoped>
  #lm-pagination
    a
      display: block
      min-width: 50px
      text-align: center
      &.page-link
        border-radius: 5px !important
    .page-link
      cursor: pointer
  #lm-pagination-numbers-mobile-wrapper
    display: none
    @media(max-width: $xl)
      display: block
    #lm-pagination-numbers-mobile
      @media(max-width: $xl)
        width: 100%
  .lm-pagination-numbers
    display: flex
    @media(max-width: $xl)
      display: none
</style>
